import { useEntity } from '@backstage/plugin-catalog-react';
import { useRomeServiceData } from '../dashboard/useRomeServiceData';


export const RomeServiceDetails = () => {

  const { entity } = useEntity();


  const serviceName =
    entity.metadata.name;


  const serviceKey =
    entity.metadata.name;


  const appKey =
    typeof entity.spec.system === 'string'
      ? entity.spec.system
      : '';


  const teamKey =
    typeof entity.spec.owner === 'string'
      ? entity.spec.owner
      : '';


  const {
    loading,
    podCount,
    imageTag,
    argocdUrl,
    bitbucketUrl,
    apiDocsUrl,
    status,
    kongEnabled,
    kongPath,
    autoscaling,
    iamRole,
  } = useRomeServiceData(
    serviceName,
    serviceKey,
    appKey,
    teamKey,
    'dev',
    'ROME',
  );


  if (loading) {
    return (
      <>
        Loading ROME API details...
      </>
    );
  }


  return (
    <div>

      <h2>
        ROME API Details
      </h2>


      <p>
        <b>Status:</b>{' '}
        {status ?? 'Unknown'}
      </p>


      <p>
        <b>Pod Count:</b>{' '}
        {podCount}
      </p>


      <p>
        <b>Current Image:</b>{' '}
        {imageTag || 'N/A'}
      </p>


      <p>
        <b>Kong Enabled:</b>{' '}
        {kongEnabled ? 'Yes' : 'No'}
      </p>


      <p>
        <b>Kong Path:</b>{' '}
        {kongPath || 'N/A'}
      </p>


      <p>
        <b>Autoscaling:</b>{' '}
        {autoscaling ? 'Enabled' : 'Disabled'}
      </p>


      <p>
        <b>IAM Role:</b>{' '}
        {iamRole ? 'Enabled' : 'Disabled'}
      </p>


      <hr />


      <div>

        {argocdUrl && (
          <a
            href={argocdUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            ArgoCD
          </a>
        )}


        {' | '}


        {bitbucketUrl && (
          <a
            href={bitbucketUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Bitbucket Repository
          </a>
        )}


        {' | '}


        {apiDocsUrl && (
          <a
            href={apiDocsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            API Docs / Swagger
          </a>
        )}

      </div>


    </div>
  );
};